﻿import moment from 'moment';

export class Timer {
    constructor(element) {
        this.element = $(element);
        this.isRunning = false;
    }

    start(minutes) {
        const clock = $(".aw-timer__clock", this.element);
        const progressBar = $(".aw-timer__progress-bar", this.element);

        const expirationDate = moment().add(minutes, "minutes");
        const totalSeconds = expirationDate.diff(moment(), "seconds");

        if (this.timerInterval != null) {
            clearInterval(this.timerInterval);
        }

        if (this.timerTimeout != null) {
            clearTimeout(this.timerTimeout);
        }

        clock.text(
            moment.utc(expirationDate.diff(moment())).format("mm:ss")
        );
        progressBar.width("100%");
        this.isRunning = true;

        this.timerInterval = setInterval(() => {
            const currentDate = moment();
            const remainingSeconds = expirationDate.diff(
                currentDate,
                "seconds"
            );
            const percentage =
                Math.trunc(((remainingSeconds * 100) / totalSeconds) * 100) / 100;

            clock.text(
                moment.utc(expirationDate.diff(currentDate)).format("mm:ss")
            );
            progressBar.width(`${percentage}%`);
        }, 1000);

        this.timerTimeout = setTimeout(() => {
            clearInterval(this.timerInterval);
            this.element.trigger("finish");
            this.isRunning = false;
        }, expirationDate.diff(moment()));
    }

    hideTimer() {
        $(".aw-timer__clock", this.element).addClass("eui-d-none");
    }

    showTimer() {
        $(".aw-timer__clock", this.element).removeClass("eui-d-none");
    }
}